import axios from 'axios';
import { UserModel, ConvertUser } from '../models/UserModel';
import { toast } from 'react-toastify';
import { CustomError } from '../models/customError';

const API_URL = process.env.REACT_APP_API_URL;

export const loginUser = async (email: string, password: string): Promise<UserModel | void> => {
  try {
    const response = await axios.post(`${API_URL}/user/login`, { email, password });
    const responseBody = response.data;

    if (response.status === 200) {
      const user = ConvertUser.toUserModel(
        JSON.stringify({
          ...responseBody.user,
          already_connected: responseBody.already_connected,
          first_login_skipped: responseBody.first_login_skipped,
        })
      );

      // console.log("Logged in user:", user);

      const token = responseBody.token;

      if (user && user.role === "ADMIN") {
        if (token) saveUserToLocalStorage(user, token);
      } else if (responseBody.first_login_skipped || responseBody.already_connected) {
        if (token) saveUserToLocalStorage(user, token);
      } else {
        // Pas de token => 2FA attendue : on garde l'email pour la page de code 2FA
        localStorage.setItem("userEmail", user.email);
      }

      return user;
    } else {
      throw new Error("Une erreur est survenue");
    }
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error("Site actuellement en cours de maintenance. Merci pour votre patience");
    }
  }
};

export const saveUserToLocalStorage = (user: UserModel, token: string) => {
  localStorage.setItem('userId', user.id.toString());
  localStorage.setItem('role', user.role);
  localStorage.setItem('reference', user.reference);
  
  // Sauvegarder de nom et prénom
  localStorage.setItem('userName', user.name || '');
  localStorage.setItem('userFirstname', user.firstname || '');

  localStorage.setItem('userEmail', user.email);
 
  localStorage.setItem('userStatus', user.status);


  // Garder le format combiné si d'autres l'utilisent
  localStorage.setItem('username', `${user.firstname} ${user.name}`);
  
  localStorage.setItem('token', token);
  localStorage.setItem('isEntreprise', JSON.stringify(user.is_entreprise));

  localStorage.setItem('isvalidated', JSON.stringify(user.is_validated));
  localStorage.setItem ('userType',user.user_type);

  localStorage.setItem('email_autorized', JSON.stringify(user.email_autorized ));
  localStorage.setItem('profilePicture', JSON.stringify(user.profile_picture));


  localStorage.setItem('show_in_directory', JSON.stringify(user.show_in_directory));
}


// services/auth.service.ts ou services/user.service.ts

export const logoutUser = async (): Promise<void> => {
  try {
    const token = localStorage.getItem("token");
    

    
    if (!token) {
      // Même sans token, on nettoie le localStorage
      clearUserLocalStorage();
      return;
    }

    const response = await axios.post(
      `${API_URL}/user/logout`,
      {}, 
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.status === 200) {
      clearUserLocalStorage();
      
      console.log("Déconnexion réussie");
    } else {
      throw new Error("Erreur lors de la déconnexion");
    }
  } catch (error: any) {
    clearUserLocalStorage();
    
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error("Une erreur est survenue lors de la déconnexion");
    }
  }
};

const clearUserLocalStorage = (): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("userRole");
  localStorage.removeItem("cart");
  localStorage.removeItem("preferences");
};

export const logoutUserWithState = async (
  clearUserState: () => void
): Promise<void> => {
  try {
    await logoutUser();
    clearUserState();
  } catch (error) {
    console.error("Erreur déconnexion:", error);
    clearUserLocalStorage();
    clearUserState();
    throw error;
  }
};
export const getAllClientByUser = async (userParent: number): Promise<UserModel[]> => {
  try {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('userId');
    if (!token) {
      throw new Error("Token not found");
    }

    const params = new URLSearchParams({
      parent: userParent.toString(),
      userIdInToken: id!.toString(),
    });

    const response = await axios.get(`${API_URL}/user/client`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`,
      },
    });

    const responseBody = response.data;

    if (response.status === 200) {
      let users = responseBody.users.map((e: any) => ConvertUser.toUserModel(JSON.stringify(e)));
      return users;
    } else {
      toast.error(`${JSON.stringify(responseBody['message'])}`);
      return [];
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.message || error.message);
    } else {
      throw new Error('Une erreur est survenue lors de la récupération de l\'ID du parent.');
    }
  }
};

export const getAllClientByUsers = async (userParent: number): Promise<UserModel[]> => {
  try {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('userId');

    if (!token) {
      throw new Error("Token not found");
    }

    const params = new URLSearchParams({
      parent: userParent.toString(),
      userIdInToken: id!.toString(),
    });

    const response = await axios.get(`${API_URL}/user`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`,
      },
    });
    // console.log("Response from getAllClientByUsers:", response);

    const responseBody = response.data;

    if (response.status === 200) {
      let users = responseBody.users.map((e: any) => ConvertUser.toUserModel(JSON.stringify(e)));
      return users;
    } else {
      toast.error(`${JSON.stringify(responseBody['message'])}`);
      return [];
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.message || error.message);
    } else {
      throw new Error('Une erreur est survenue lors de la récupération de l\'ID du parent.');
    }
  }
};


